// Copyright (C) 2023 CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

import './styles.scss';

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Row, Col } from 'antd/lib/grid';
import Text from 'antd/lib/typography/Text';
import Spin from 'antd/lib/spin';
import notification from 'antd/lib/notification';
import { Reference } from 'reducers';
import { useIsMounted } from 'utils/hooks';
import { getCore } from 'cvat-core-wrapper';
import ReferenceJobForm from './reference-job-form';

const core = getCore();

function CreateReferenceJobPage(): JSX.Element {
    const [fetchingReference, setFetchingReference] = useState(true);
    const [referenceInstance, setReferenceInstance] = useState<Reference | null>(null);
    const isMounted = useIsMounted();

    const id = +useParams<{ id: string }>().id;
    useEffect((): void => {
        if (Number.isInteger(id)) {
            core.references.get({ id })
                .then(([reference]: Reference[]) => {
                    if (isMounted() && reference) {
                        setReferenceInstance(reference);
                    }
                }).catch((error: Error) => {
                    if (isMounted()) {
                        notification.error({
                            message: 'Could not fetch requested reference from the server',
                            description: error.toString(),
                        });
                    }
                }).finally(() => {
                    if (isMounted()) {
                        setFetchingReference(false);
                    }
                });
        } else {
            notification.error({
                message: 'Could not receive the requested reference from the server',
                description: `Requested reference id "${id}" is not valid`,
            });
            setFetchingReference(false);
        }
    }, []);
    return (
        <div className='cvat-create-reference-job-page'>
            <Row justify='center' align='middle'>
                <Col>
                    <Text className='cvat-title'>Add a new job</Text>
                </Col>
            </Row>
            {
                fetchingReference ? (
                    <div className='cvat-create-reference-job-loding'>
                        <Spin size='large' className='cvat-spinner' />
                    </div>
                ) : (
                    <Row justify='center' align='top'>
                        <Col md={20} lg={16} xl={14} xxl={9}>
                            <ReferenceJobForm reference={referenceInstance} />
                        </Col>
                    </Row>
                )
            }
        </div>
    );
}

export default React.memo(CreateReferenceJobPage);
